export default __webpack_public_path__ + "images/inmarket-logo-shape.ff2fdd3088f3e84537cbae2c2b53e592.png";